export const paginationStartStyle = {
  fontSize: "12px",
  color: "#807F94",

  "& .select-wrapper": {
    backgroundColor: "transparent",
    border: "1px solid #E2E8F0",
    borderRadius: "6px",
    paddingX: "8px",
    paddingY: "8px",
  },
  "& select,select:focus,select:active": {
    backgroundColor: "transparent",
    border: "none",
    outline: "none",
  },
};
